import { useEffect } from "react";
import { NavbarHeader, PortalFooter } from "components/templates";
import { ZendeskProvider } from "providers/ZendeskProvider";
import { useAppContext } from "context/app-context";
import { useCartContext } from "context/cart-context";
import { NotificationBanner } from "components/UI/organisms";
import { guessIsWebView } from "services/webview";
import "./index.scss";
import { useRouteChange } from "hooks/useRouteChange";

export const PageLayout = ({ children }) => {
  const { getSessionInfo, sessionInfo } = useAppContext();
  const { getInitialCards } = useCartContext();

  useEffect(() => {
    // fetch initial user session info
    getSessionInfo();
  }, [getSessionInfo]);

  useRouteChange();

  useEffect(() => {
    // fetch user cart items if he had associated items with his ID
    sessionInfo?.userID && getInitialCards({ userID: sessionInfo.userID });
  }, [sessionInfo?.userID, getInitialCards]);

  return guessIsWebView() ? (
    <div className="webview-active">{children}</div>
  ) : (
    <>
      {sessionInfo?.featureToggles?.isZendeskEnabled && <ZendeskProvider />}
      <NavbarHeader />
      <NotificationBanner />
      {children}
      <PortalFooter />
    </>
  );
};
